import React from 'react';
import classnames from 'classnames';

const LoadingPage = () => {
  const pageCssBEM = 'detailsPage';
  const classes = classnames({
    [pageCssBEM]: true,
    [`${ pageCssBEM }--skeleton`]: true
  });

  return (
    <div className={ classes }>
      <h1 className={ `${ pageCssBEM }__title` }>
        <div/>
        <span/>
        <span/>
        <span/>
      </h1>
    </div>
  );
};

export default LoadingPage;
